import React from 'react'
import moment from 'moment';
import 'moment-duration-format';
import styles from './style.module.css'


const DurationBadge = ({totalDuration}: any) => {
    return (
        <span className={`badge bg-secondary ms-2 ${styles.durationBadge}`}>
            {moment.duration(totalDuration, "seconds").format("hh:mm:ss", {trim: "large", stopTrim: "mm"})}
        </span>
    )
}

export default DurationBadge
